const u = (id) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=1200&q=80`;

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PHONE_DISPLAY = "(815) 289-0523";
export const PHONE_TEL = "tel:+18152890523";

export const IMAGES = {
  hero: u("photo-1654742324155-499a832a0347"),
  retreat: u("photo-1790272689226-0b43171a1394"),
  founders: "https://customer-assets-rejwkqb3.emergentagent.net/job_military-marriages--3zdebz0z/artifacts/0f4ca0d48927e4af_image.webp",
};

export const AUDIENCES = [
  { label: "Active-duty couples", img: u("photo-1655759738595-418970010986") },
  { label: "Couples facing deployment or relocation", img: u("photo-1714647211945-0f70c4849f38") },
  { label: "Military spouses on their own", img: u("photo-1598024055266-e772a5f8c128") },
  { label: "Veterans and their spouses", img: u("photo-1727518493223-cd3dd2c4cbd9") },
  { label: "Couples that are restoring their marriage", img: u("photo-1564020435666-f67ed5319a32") },
  { label: "All military families", img: u("photo-1620010907214-0a2517895ead") },
];

export const BELIEFS = [
  "We understand deployment and PCS stress",
  "Confidential, judgment-free support",
  "Faith and spiritual guidance support and growth",
  "For all military families",
];

export const DONATION_OPTIONS = [
  { key: "donate_25", label: "$25" },
  { key: "donate_50", label: "$50" },
  { key: "donate_100", label: "$100" },
  { key: "donate_250", label: "$250" },
  { key: "donate_custom", label: "Other amount" },
];

export const MONTHLY_OPTIONS = [
  { key: "monthly_10", label: "$10/mo" },
  { key: "monthly_25", label: "$25/mo" },
  { key: "monthly_50", label: "$50/mo" },
  { key: "monthly_custom", label: "Other amount" },
];
